// Mock of the trading settings the backend will return, values from moon.com
// (docs/trade-logic.md 4.6, docs/missing-logic.md 3)

/**
 * Global settings, Moon's GetTradingSettings.
 */
export const TRADING_SETTINGS = {
  maxLeverage: 1000,
  maxProfit: 500000,
  maxTradeAmount: 10000000,
  minTradeAmount: 0.1,
};

const BASE_RISK_SETTINGS = {
  marketImpactBaseRate: 0.1,
  marketImpactMinMove: 0.0001,
  marketImpactMinPayoutFactor: 0.25,
  marketImpactMoveExponent: 1,
  marketImpactReferenceMove: 0.000789,
  marketImpactSizeExponent: 0,
};

const riskSettings = (overrides) => ({ ...BASE_RISK_SETTINGS, ...overrides });

/**
 * Per asset settings by ticker, Moon's GetAssetSettings
 * (assetSetting.symbol.riskSettings) and the asset's max profit.
 * maxProfit null: not known yet, the global one is used.
 */
export const ASSET_SETTINGS = {
  BTC: {
    maxProfit: 200000,
    riskSettings: riskSettings({ marketImpactLiquidityUnit: 1000000 }),
  },
  ETH: {
    maxProfit: null,
    riskSettings: riskSettings({ marketImpactLiquidityUnit: 500000 }),
  },
  SOL: {
    maxProfit: null,
    riskSettings: riskSettings({ marketImpactLiquidityUnit: 350000 }),
  },
  ZEC: {
    maxProfit: 80000,
    riskSettings: riskSettings({ marketImpactLiquidityUnit: 200000 }),
  },
  TRX: {
    maxProfit: null,
    riskSettings: riskSettings({
      marketImpactLiquidityUnit: 100000,
      marketImpactMinPayoutFactor: 0.1,
      marketImpactReferenceMove: 0.002,
    }),
  },
  // Move and size exponents weren't read for XAU, the crypto ones (1 and 0)
  // reproduce Moon's ROI table
  XAU: {
    maxProfit: 80000,
    riskSettings: riskSettings({ marketImpactLiquidityUnit: 5000000 }),
  },
};
